import React from "react";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import {Button} from "reactstrap";
import {toast} from "react-toastify";

class Services extends Framework.Components.Collection {
	constructor(props) {
		super(props, new API.BuildClass(Types.Services._name, API.RequestType.READ_ALL));
		this.state.limit = 16;
		this.limit = 16;
	}

	addToCart = (service, taxable = true) => () => {
		const item = new API.BuildClass(Types.Checkouts_Services._name, API.RequestType.CREATE);
		item.object = {
			service: service,
			quantity: "1",
			taxable: taxable,
		};
		item.submit(null, API.RequestType.CREATE).then(() => {
			this.handleCheckoutIncrement();
		}).catch((err) => {
			const msg = err?.message || 'Could not add service to checkout.';
			toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
		});
	};

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count:
				this.props.rootState.session_items_count === null
					? 1
					: 1 + this.props.rootState.session_items_count,
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "pkey",
				className: 'center-column',
				Cell: (props) => (
					<Link to={`/services/${props.value}`}>{props.original.name}</Link>
				),
			},
			{
				Header: "Price",
				id: "price",
				accessor: (r) => `$${parseFloat(r.price || 0).toFixed(2)}`,
				Cell: (props) => <div style={{textAlign: "right"}}>{props.value}</div>,
			},
			{
				Header: "Cost",
				id: "price_purchase",
				accessor: (r) => r.price_purchase !== null ? "$" + r.price_purchase : "",
				Cell: (props) => <div style={{textAlign: "right"}}>{props.value}</div>,
			},
			{
				Header: "Taxable",
				id: "taxable",
				className: 'center-column',
				accessor: (r) => (r.taxable ? "Yes" : "No"),
			},
			{
				Header: "Notes",
				id: "notes",
				accessor: (r) => r.notes || "",
			},
			{
				Header: "Checkout",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 120,
				Cell: (props) => (
					<Button
						className="primary-button pull-right"
						style={{ marginTop: '6px' }}
						onClick={this.addToCart(props.original.pkey, props.original.taxable)}
						size="sm"
						block
					>
						<i className="fa fa-shopping-cart" />
						&nbsp;&nbsp;Add
					</Button>
				),
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: (props) => (
					<Link to={`/services/${props.original.pkey}`}>
						<Button color="green-meadow" size="sm" block style={{ marginTop: '6px' }}>
							<i className="fa fa-pencil" />
						</Button>
					</Link>
				),
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch("Services")}
							{this.renderHeaderRight("Services", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						onPageSizeChange={this.onPageSizeChange}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === "desc",
							},
						]}
						showPagination
						showPaginationTop={false}
						showPaginationBottom
						showPageSizeOptions
						defaultPageSize={limit}
						className="-striped -highlight"
					/>
					{APPCONFIG.settings.isDev() ? null : (
						<div className={classNames("tabled", "loader", {active: loading})}>
							<ClipLoader color="#4A4A4A" loading={loading} />
						</div>
					)}
				</CardContent>
			</Card>
		);
	}
}

export default Framework.Components.withRootState(Services);
